// extracted by mini-css-extract-plugin
export default {"spin_wrapper":"HeaderSpiner_spin_wrapper__mFXvZ","spinner":"HeaderSpiner_spinner__Kvb9H","spin":"HeaderSpiner_spin__whG5V"};